module.exports = __webpack_public_path__ + "fonts/Graphik-Extralight-Web.b32258d.woff";